export default __webpack_public_path__ + "static/media/cookingoils-bottles.ef46a04d.png";